import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import { GetProfile } from '../../../../services/api/profile-api';
import { GetAllNotificationByUserNew, MarkAllNotificationAsReadByUserNew } from '../../../../services/api/notification-api';
import NotificationTable from '../notification-table/notification-table';
import Pagination from '../../../../components/pagination/Pagination';
import './notification-panel.scss'
import { GetAllUsers, GetAllUsersNew } from '../../../../services/api/user-api';
import { User_Logout } from "../../../../services/auth";
import { PulseLoader } from 'react-spinners';

const defaultNotificationFilters = {
    pageSize: 10,
    pageNumber: 1,
    filters: [],
};

const empltyNotificationData = [
    {
        "description": "No Notifications",
        "link": "",
        "author": null,
        "time": null,
        "section": null,
        "notificationId": 0,
        "senderId": 0,
        "isRead": 0,
        "profileImage": "/Assets/Images/no-photo.jpg"
    }
];

const NotificationPanelNew = () => {
    const [state, setState] = useState({
        user: null,
        loading: true,
        notifications: [],
        notificationCount: 0,
        notificationFilters: defaultNotificationFilters,
        users: [],
        selectedUsers: []
    });

    const [alertState, setAlertState] = useState({
        showAlert: false,
        alertAction: "",
        alertMessage: "",
        alertVariant: "danger",
    });

    useEffect(() => {
        const fetchData = async () => {
            if (!state.user) {
                const userData = await GetProfile();
                if (userData == null) {
                    User_Logout();
                    return;
                }
                setState(prevState => ({ ...prevState, user: userData }));
            }

            loadNotifications();
        };

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state.notificationFilters, state.user]);

    const loadNotifications = async () => {
        setState(prevState => ({ ...prevState, notifications: [], loading: true }));
        try {
            const allUsers = await GetAllUsersNew({ filters: [], sortDesc: false, sortBy: "name", pageSize: 1000, pageNumber: 1 });
            const result = await GetAllNotificationByUserNew({ PageNumber: state.notificationFilters.pageNumber, PageSize: state.notificationFilters.pageSize, Filters: state.notificationFilters.filters });
            let resultData = result.data;
            if (resultData.Notifications === null) {
                resultData.Notifications = empltyNotificationData;
            }
            setState(prevState => ({
                ...prevState,
                users: allUsers.Users,
                notifications: resultData.Notifications,
                notificationCount: resultData.NotificationCount,
                loading: false
            }));
            setAlertState(prevState => ({ ...prevState, alertVariant: "success" }));
        } catch (error) {
            console.error("Error loading notifications:", error);
            setAlertState(prevState => ({ ...prevState, alertVariant: "danger" }));
        }
    };

    const markAllAsRead = async () => {
        try {
            await MarkAllNotificationAsReadByUserNew();
            setState(prevState => ({
                ...prevState,
                notificationFilters: { ...prevState.notificationFilters, ...defaultNotificationFilters }
            }));
            setAlertState(prevState => ({
                ...prevState,
                showAlert: true,
                alertAction: "Marked all as read",
                alertVariant: "success"
            }));
        } catch (error) {
            console.error("Error marking all notifications as read:", error);
            setAlertState(prevState => ({
                ...prevState,
                showAlert: true,
                alertAction: "Could not mark all as read.",
                alertMessage: "Could not mark all as read."
            }));
        }
    };

    const displayAlert = () => {
        setTimeout(() => {
            setAlertState(prevState => ({ ...prevState, showAlert: false }));
        }, 5000);

        return (
            <Alert show={alertState.showAlert} onClose={() => setAlertState(prevState => ({ ...prevState, showAlert: false }))} variant={alertState.alertVariant} dismissible>
                <Alert.Heading>{alertState.alertAction}</Alert.Heading>
                <p>{alertState.alertMessage}</p>
                <hr />
            </Alert>
        );
    }

    const save = (selectedList, list, name, column, value, parameter, clearFilter) => {
        let updatedFilters = { ...state.notificationFilters };
        updatedFilters[name] = selectedList;
        setState(prevState => ({ ...prevState, notificationFilters: updatedFilters, selectedUsers: selectedList}));

        if (clearFilter || selectedList.length === 0 || selectedList.length === state.users.length) {
            let filters = state.notificationFilters.filters;
            let index = filters.findIndex(filter => filter.column === column);

            if (index > -1) {
                filters.splice(index, 1);
                setState(prevState => ({ ...prevState, notificationFilters: { ...prevState.notificationFilters, filters: filters } }));
            }
        } else {
            let ids = [];
            selectedList.forEach(key => {
                key.forEach(item => {
                    ids.push(item[parameter]);
                });
            });

            if (state.notificationFilters.filters.map(filter => filter.column === column).includes(true)) {
                setState(prevState => ({
                    ...prevState,
                    notificationFilters: {
                        ...prevState.notificationFilters,
                        pageNumber: 1,
                        filters: prevState.notificationFilters.filters.map(filter => {
                            if (filter.column === column) {
                                filter[value] = ids;
                                return filter;
                            } else {
                                return filter;
                            }
                        })
                    }
                }));
            } else {
                let newFilter = state.notificationFilters.filters;
                let tempObj = { column: column };
                tempObj[value] = ids;
                newFilter.push(tempObj);
                setState(prevState => ({
                    ...prevState,
                    notificationFilters: {
                        ...prevState.notificationFilters,
                        pageNumber: 1,
                        filters: newFilter
                    }
                }));
            }
        }
    }

    const nextPage = () => {
        if (((state.notificationFilters.pageNumber + 1) * 10) - state.notificationCount < 10) {
            setState(prevState => ({
                ...prevState,
                notificationFilters: {
                    ...prevState.notificationFilters,
                    pageNumber: prevState.notificationFilters.pageNumber + 1
                }
            }));
        }
    };

    const prevPage = () => {
        if (state.notificationFilters.pageNumber > 1) {
            setState(prevState => ({
                ...prevState,
                notificationFilters: {
                    ...prevState.notificationFilters,
                    pageNumber: prevState.notificationFilters.pageNumber - 1
                }
            }));
        }
    };

    const rowChange = (numRows) => {
        setState(prevState => ({
            ...prevState,
            notificationFilters: {
                ...prevState.notificationFilters,
                pageSize: numRows,
                pageNumber: 1
            }
        }));
    };

    return (
        <div>
            {alertState.showAlert ? displayAlert() : null}
            <div className="table-container">
                <div className="control-width">
                    <Form className="table-control">
                        <Form.Group className="mark-notification-button" controlId="markNotification">
                            <Button className="btn-outlined btn-wide" title="Mark All As Read" data-testid="markAllAsRead" onClick={markAllAsRead}>Mark All As Read</Button>
                        </Form.Group>
                        <div className="right pagination-container" style={{ "paddingTop": "2px" }}>
                            {state.notificationCount > 0 && <Pagination refresh={loadNotifications} next={nextPage} prev={prevPage} rowChange={rowChange} numEntries={state.notificationCount} query={state.notificationFilters} />}
                        </div>
                    </Form>
                </div>
                {!state.loading ? (
                    <NotificationTable
                        key={JSON.stringify(state.notifications)}
                        notifications={state.notifications}
                        users={state.users}
                        selectedUsers={state.selectedUsers}
                        save={save}
                    />
                ) : (
                    <div className="pulse-loader">
                        <PulseLoader></PulseLoader>
                    </div>
                )}
            </div>
        </div>
    );
};

export default NotificationPanelNew;